<div class="general_section">
  <div class="general_section_header">
    <div class="general_block_header">
      <div class="header_section_g">
        <div class="header_section_info">
          <div style="overflow-y: hidden">
            <img class="lineUp logo_first" src="assets/images/shared/generalPage/logoFirst.svg"/>
            <img class="lineUp logo_second" src="assets/images/shared/generalPage/logoSecond.svg"/>
          </div>
          <div style="display: flex; flex-direction: column; overflow: hidden;">
            <span class="common_big_span">{{localize.language.investmentText}}</span>
            <span class="common_big_span">{{localize.language.clientText}}</span>
          </div>
        </div>
        <button (click)="openAccount()">{{localize.language.openAccount}}</button>
      </div>
    </div>
  </div>

  <div style="background-color: #fff; padding: 0 20px; display: flex; justify-content: center">
    <div class="about_us_section">
      <div class="about_us_upper_section">
        <h2>{{localize.language.aboutUs}}</h2>
        <div class="about_us_upper_info">
          <span class="common_big_span_grey">{{localize.language.aboutUsInfo}}</span>
          <span class="common_big_span_grey" style="text-decoration: underline; cursor: pointer" routerLink="/company">{{localize.language.more}}</span>
        </div>
      </div>

      <div class="about_us_lower_section">
        <div class="about_us_lower_item">
          <img width="80px" style="transform: rotate(90deg)" src="assets/images/shared/ui-kit/generalInnerCircleLight.gif" alt="logo">
          <div class="about_us_lower_item_info">
            <h2>{{localize.language.lowCosts}}</h2>
            <span class="common_big_span_grey">{{localize.language.lowCostsText}}</span>
          </div>
        </div>

        <div class="about_us_lower_item">
          <img width="80px" src="assets/images/shared/ui-kit/generalDownArrowLight.gif" alt="logo">
          <div class="about_us_lower_item_info">
            <h2>{{localize.language.globalAccess}}</h2>
            <span class="common_big_span_grey">{{localize.language.globalAccessText}}</span>
          </div>
        </div>

        <div style="gap:46px" class="about_us_lower_item">
          <img width="120px" src="assets/images/shared/ui-kit/generalCircleLight.gif" alt="logo">
          <div class="about_us_lower_item_info">
            <h2>{{localize.language.tools}}</h2>
            <span class="common_big_span_grey">{{localize.language.toolsText}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="crypto_section">
    <div class="crypto_inner_section">
      <img src="../../../../assets/images/shared/generalCryptoMobile.svg"/>
      <div class="crypto_inner_info">
        <div class="crypto_header">
          <h2>{{localize.language.withCrypto}}</h2>
          <h2>{{localize.language.whatProfit}}</h2>
        </div>

        <div class="crypto_inner_text">
          <div class="crypto_inner_item_block">
            <div class="crypto_inner_separator">01</div>
            <div class="crypto_inner_item_info">
              <h2>{{localize.language.highSpeed}}</h2>
              <span class="common_big_span_grey">{{localize.language.highSpeedText}}</span>
            </div>
          </div>

          <div class="crypto_inner_item_block">
            <div class="crypto_inner_separator">02</div>
            <div class="crypto_inner_item_info">
              <h2>{{localize.language.withoutRestrictions}}</h2>
              <span class="common_big_span_grey">{{localize.language.withoutRestrictionsText}}</span>
            </div>
          </div>

          <div class="crypto_inner_item_block">
            <div class="crypto_inner_separator">03</div>
            <div class="crypto_inner_item_info">
              <h2>{{localize.language.safety}}</h2>
              <span class="common_big_span_grey">{{localize.language.safetyText}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="awards_section">
    <div class="awards_title">
      <span class="common_medium_span">{{localize.language.awards}}</span>
    </div>
    <div class="awards_block_item">
      <div class="award_item">
        <img src="assets/images/shared/awards/awardsDetailed/awards20221.svg" alt="logo">
        <div class="award_item_inner">
          <ul>
            <li>{{localize.language.awards20221textLi1}}</li>
            <li>{{localize.language.awards20221textLi2}}</li>
            <li>{{localize.language.awards20221textLi3}}</li>
          </ul>

          <div class="awards_footer">
            <span class="common_extra_small_span_grey">{{localize.language.barrons}}</span>
            <span class="common_extra_small_span_grey">2022</span>
          </div>
        </div>
      </div>

      <div class="award_item">
        <img src="assets/images/shared/awards/awardsDetailed/awards20222.svg" alt="logo">
        <div class="award_item_inner">
          <ul>
            <li>{{localize.language.awards20223}}</li>
          </ul>

          <div class="awards_footer">
            <span class="common_extra_small_span_grey">{{localize.language.investopedia}}</span>
            <span class="common_extra_small_span_grey">2022</span>
          </div>
        </div>
      </div>

      <div class="award_item">
        <img src="assets/images/shared/awards/awardsDetailed/awards20224.svg" alt="logo">
        <div class="award_item_inner">
          <ul>
            <li>{{localize.language.awards20224textLi1}}</li>
            <li>{{localize.language.awards20224textLi3}}</li>
          </ul>

          <div class="awards_footer">
            <span class="common_extra_small_span_grey">{{localize.language.brokerchooser}}</span>
            <span class="common_extra_small_span_grey">2022</span>
          </div>
        </div>
      </div>
    </div>

    <div class="awards_button_section">
      <button class="common_button transparent_button" routerLink="/awards">{{localize.language.allAwards}}
        <span class="awards_count">24</span>
      </button>
    </div>
  </div>


  <div class="awards_section">
    <div class="awards_title">
      <span class="common_medium_span">{{localize.language.availabilities}}</span>
    </div>
    <div class="availability_block">
      <div class="availability_info">
        <h2>{{localize.language.investmentTextNew}}</h2>

        <div class="availability_info_numbers">
          <div class="availability_numbers_item">
            <h1>150</h1>
            <span class="common_big_span">{{localize.language.markets}}</span>
          </div>

          <div class="availability_numbers_item">
            <h1>33</h1>
            <span class="common_big_span">{{localize.language.countries}}</span>
          </div>
        </div>
      </div>
    </div>

    <app-map-mobile></app-map-mobile>
  </div>

  <div class="footer_menu_section">
    <div class="footer_menu_inner_section">
      <div class="footer_menu_item">
        <h1>{{localize.language.openAccountText}}</h1>
        <button class="small_button dark_button" routerLink="/account">{{localize.language.openAccount}}</button>
      </div>
    </div>
  </div>

  <app-footer-links></app-footer-links>
</div>

<app-qa-popup *ngIf="qaModalStatus"></app-qa-popup>

